import { p as proxyCustomElement, H, c as createEvent, h, a as Host } from './index.js';
import { w as waitForAnimation } from './p-rUtJRH95.js';
import { d as defineCustomElement$6 } from './p-sF9rvBC9.js';
import { d as defineCustomElement$5 } from './p-C5OQSByn.js';
import { d as defineCustomElement$4 } from './p-BDIehgMZ.js';
import { d as defineCustomElement$3 } from './p-Trmgzgcp.js';
import { d as defineCustomElement$2 } from './p-KbTC_jnR.js';

const toastCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;bottom:0;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;left:0;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;pointer-events:none;position:fixed;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{align-items:center;bottom:0;display:flex;justify-content:center;left:0;min-height:100%;pointer-events:none;position:relative;right:0;top:0;z-index:var(--jw-z-index-overlays)}:host .backdrop{background-color:#000000b3;bottom:0;left:0;opacity:0;pointer-events:none;position:fixed;right:0;top:0;transition:opacity .25s ease;z-index:calc(var(--jw-z-index-overlays) - 1)}:host .backdrop.-anim-fade-in{animation:fade-in .25s linear forwards;pointer-events:all}@keyframes fade-in{0%{opacity:0}to{opacity:1}}:host .backdrop.-anim-fade-out{animation:fade-out .25s linear forwards}@keyframes fade-out{0%{opacity:1}to{opacity:0}}:host .content{pointer-events:all;z-index:calc(var(--jw-z-index-overlays) + 1)}.content{align-items:center;border-radius:.25rem;bottom:1rem;display:flex;gap:1.5rem;max-width:var(--jw-container-md);opacity:0;padding:1rem;position:absolute;right:1rem;transform:translateY(calc(100% + 1rem));transition:box-shadow .2s linear 10ms,margin-bottom .2s ease}@keyframes wui-toast-open{0%{opacity:0}10%{opacity:0;transform:translateY(calc(100% + 1rem))}90%{opacity:1}to{opacity:1;transform:translateY(0)}}@keyframes wui-toast-close{0%{opacity:1;transform:translateX(0)}90%{opacity:0}to{opacity:0;transform:translateX(1rem)}}.content.-anim-open{animation:wui-toast-open .25s cubic-bezier(.25,.46,.45,.94) forwards}.content.-anim-close{animation:wui-toast-close .25s cubic-bezier(.25,.46,.45,.94) forwards}.body{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.actions{align-items:center;display:flex;flex:none;gap:.5rem}:host([type=info]) .content{background-color:var(--jw-theme-info-bold-message-bg-color)}:host([type=info]) .body{color:var(--jw-theme-info-bold-message-color)}:host([type=error]) .content{background-color:var(--jw-theme-error-bold-message-bg-color)}:host([type=error]) .body{color:var(--jw-theme-error-bold-message-color)}:host([type=warning]) .content{background-color:var(--jw-theme-warning-bold-message-bg-color)}:host([type=warning]) .body{color:var(--jw-theme-warning-bold-message-color)}:host([type=success]) .content{background-color:var(--jw-theme-success-bold-message-bg-color)}:host([type=success]) .body{color:var(--jw-theme-success-bold-message-color)}:host([data-display=open]) .content{box-shadow:var(--jw-theme-effects-shadow-shadow-lg-box-shadow)}:host(:nth-of-type(2)) .content{margin-bottom:4rem}:host(:nth-of-type(3)) .content{margin-bottom:8rem}:host(:nth-of-type(4)) .content{margin-bottom:12rem}:host(:nth-of-type(5)) .content{margin-bottom:16rem}:host(:nth-of-type(6)) .content{margin-bottom:20rem}:host(:nth-of-type(7)) .content{margin-bottom:24rem}:host(:nth-of-type(8)) .content{margin-bottom:28rem}:host(:nth-of-type(9)) .content{margin-bottom:32rem}:host(:nth-of-type(10)) .content{margin-bottom:36rem}:host(:nth-of-type(11)) .content{margin-bottom:40rem}:host(:nth-of-type(12)) .content{margin-bottom:44rem}:host(:nth-of-type(13)) .content{margin-bottom:48rem}:host(:nth-of-type(14)) .content{margin-bottom:52rem}:host(:nth-of-type(15)) .content{margin-bottom:56rem}:host(:nth-of-type(16)) .content{margin-bottom:60rem}:host(:nth-of-type(17)) .content{margin-bottom:64rem}:host(:nth-of-type(18)) .content{margin-bottom:68rem}:host(:nth-of-type(19)) .content{margin-bottom:72rem}:host(:nth-of-type(20)) .content{margin-bottom:76rem}:host(:nth-of-type(21)) .content{margin-bottom:80rem}:host(:nth-of-type(22)) .content{margin-bottom:84rem}:host(:nth-of-type(23)) .content{margin-bottom:88rem}:host(:nth-of-type(24)) .content{margin-bottom:92rem}:host(:nth-of-type(25)) .content{margin-bottom:96rem}:host(:nth-of-type(26)) .content{margin-bottom:100rem}:host(:nth-of-type(27)) .content{margin-bottom:104rem}:host(:nth-of-type(28)) .content{margin-bottom:108rem}:host(:nth-of-type(29)) .content{margin-bottom:112rem}:host(:nth-of-type(30)) .content{margin-bottom:116rem}:host(:nth-of-type(n+31)){display:none}";

const WuiToast$1 = /*@__PURE__*/ proxyCustomElement(class WuiToast extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.displayChanged = createEvent(this, "displayChanged", 3);
        /**
         * Display toast for x ms
         *
         * Defaults to:
         *  3000ms: Toast without action
         *  5000ms: Toast with action
         */
        this.timeout = this.hyperlink ? 5000 : 3000;
        /**
         * Toast type
         */
        this.type = 'info';
        this.contentAnimClass = '';
        this.display = 'closed';
        this.animate = async ({ content }) => {
            const promise = waitForAnimation(this.elm.querySelector('.content'));
            if (content) {
                this.contentAnimClass = content;
            }
            await promise;
        };
        this.handleDismiss = () => {
            this._setDisplay('closed');
        };
    }
    /**
     * Set display state.
     *
     * Possible values: `'open'`, `'closed'`.
     */
    async setDisplay(value) {
        if (value === this.display) {
            return;
        }
        return this._setDisplay(value);
    }
    _mouseOver() {
        this._timeout && clearTimeout(this._timeout);
    }
    _mouseOut() {
        // Start timeout
        this.updateTimeout();
    }
    _setDisplay(value) {
        return new Promise((resolve) => {
            window.requestAnimationFrame(() => {
                switch (value) {
                    case 'open':
                        this.animate({
                            content: '-anim-open',
                        }).then(() => {
                            // Set display class immediately
                            this.display = 'open';
                            this.displayChanged.emit(this.display);
                            this.updateTimeout();
                            resolve();
                        });
                        break;
                    case 'closed':
                        this.animate({
                            content: '-anim-close',
                        }).then(() => {
                            window.requestAnimationFrame(() => {
                                // Wait for animations to finish before resetting state
                                this.display = 'closed';
                                // ℹ️ The API also listens to this event and will remove the toast from its internal state.
                                this.displayChanged.emit(this.display);
                                resolve();
                            });
                        });
                        break;
                    default:
                        resolve();
                        break;
                }
            });
        });
    }
    updateTimeout() {
        if (typeof this.timeout !== 'number') {
            return;
        }
        if (this._timeout) {
            clearTimeout(this._timeout);
        }
        this._timeout = setTimeout(() => {
            this.setDisplay('closed');
        }, this.timeout);
    }
    render() {
        return (h(Host, { key: '29c79338cadd10e7580fb788f56aaac0f27fd70a', id: this.uid ? `wui_toast__${this.uid}` : '', "data-display": this.display }, h("div", { key: 'a043576ca131c4dd544b4ecb8a228f303aa099e4', class: "container" }, h("div", { key: '339e1f1559d40274ca8ff786992f8e2fb8d6b221', class: `content ${this.contentAnimClass}` }, h("div", { key: '1d8c50277f8b2595ae9a0843f041e051a60d4467', class: "body", title: this.msg }, this.msg), h("div", { key: '24d30a3b5ff051345de7ec338330df1b27c204c5', class: "actions" }, this.hyperlink && h("wui-hyperlink", { key: '0a4e8ddce3311bdb6f13d5b259dd62a23d00ec87', type: "inverted", ...this.hyperlink }), h("wui-close-button", { key: '0b8c046ce0ade08eafe725c4144d373738d0d877', type: "bold", onClick: this.handleDismiss }))))));
    }
    get elm() { return this; }
    static get style() { return toastCss; }
}, [257, "wui-toast", {
        "uid": [1],
        "api": [16],
        "msg": [1],
        "hyperlink": [16],
        "timeout": [8],
        "type": [513],
        "contentAnimClass": [32],
        "display": [32],
        "setDisplay": [64]
    }, [[1, "mouseover", "_mouseOver"], [1, "mouseout", "_mouseOut"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-toast", "wui-close-button", "wui-hyperlink", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-toast":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiToast$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-hyperlink":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiToast = WuiToast$1;
const defineCustomElement = defineCustomElement$1;

export { WuiToast, defineCustomElement };
